import type {TokenClaimsSerializer} from "@/generated/DjangoTypes";
import useTokenStore from "@/store/token";
import {createFileRoute, redirect} from "@tanstack/react-router";
import {zodValidator} from "@tanstack/zod-adapter";
import {jwtDecode} from "jwt-decode";
import {z} from "zod";

export const Route = createFileRoute("/_authenticated/chat")({
  beforeLoad: async ({search}) => {
    const token = useTokenStore.getState().access;

    if (!token) {
      throw redirect({to: "/login", replace: true});
    }

    const claims = jwtDecode<TokenClaimsSerializer>(token);
    const agencyId = claims.agency_ids?.[0]!;
    const isAgency = claims.access_level === "AGENCY";

    if (isAgency) {
      throw redirect({
        to: "/agency/$agencyId/chat/$companyId/{-$campaignId}/{-$influencerUserId}",
        params: {
          agencyId,
          campaignId: search["campaign-id"],
          companyId: search["company-id"]!,
          influencerUserId: search["influencer-user-id"],
        },
      });
    }

    throw redirect({
      to: "/company/$companyId/chat/{-$campaignId}/{-$influencerUserId}",
      params: {
        companyId: search["company-id"]!,
        campaignId: search["campaign-id"],
        influencerUserId: search["influencer-user-id"],
      },
    });
  },
  validateSearch: zodValidator(
    z.object({
      "campaign-id": z.number().optional(),
      "company-id": z.number().optional(),
      "influencer-user-id": z.number().optional(),
    }),
  ),
});
